module.exports = __webpack_public_path__ + "img/vivo_15.5419d7d8.jpg";